// Mock Users Data
// Extracted from CreditManagement.tsx and other user-related components

export interface UserCreditData {
  user_id: string;
  email: string;
  name?: string;
  balance: number;
  last_updated: string;
}

export const mockUsers: UserCreditData[] = [
  {
    user_id: 'user-1',
    email: 'john@example.com',
    name: 'John Doe',
    balance: 25.50,
    last_updated: new Date().toISOString()
  },
  {
    user_id: 'user-2',
    email: 'jane@example.com',
    name: 'Jane Smith',
    balance: 150.00,
    last_updated: new Date().toISOString()
  },
  {
    user_id: 'user-3',
    email: 'bob@example.com',
    name: 'Bob Johnson',
    balance: 0.00,
    last_updated: new Date().toISOString()
  },
  {
    user_id: 'user-4',
    email: 'sarah@example.com',
    name: 'Sarah Wilson',
    balance: 75.25,
    last_updated: new Date().toISOString()
  },
  {
    user_id: 'user-5',
    email: 'mike@example.com',
    name: 'Mike Davis',
    balance: 200.00,
    last_updated: new Date().toISOString()
  }
]; 